import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/EngagementPostV2.graphql';
import { Query, QueryengagementPostV2Args } from '../../__generated__/globalTypes';

export const useEngagementPostV2Query = (options?: QueryHookOptions<Query, QueryengagementPostV2Args>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryengagementPostV2Args>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useEngagementPostV2LazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryengagementPostV2Args>
): QueryResult<Query, QueryengagementPostV2Args> & {
  getEngagementPostV2: LazyQueryExecFunction<Query, QueryengagementPostV2Args>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getEngagementPostV2, result] = useLazyQuery<Query, QueryengagementPostV2Args>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getEngagementPostV2, ...result };
};

export const useEngagementPostV2PromiseQuery = () => {
  const client = useApolloClient();

  const getEngagementPostV2 = useCallback(
    (options?: Omit<QueryOptions<QueryengagementPostV2Args, Query>, 'query'>) =>
      client.query<Query, QueryengagementPostV2Args>({ ...options, query: QUERY }),
    [client]
  );

  return { getEngagementPostV2 };
};
// Suspense Query Hooks
export const useEngagementPostV2SuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryengagementPostV2Args>
) => {
  const result = useSuspenseQuery<Query, QueryengagementPostV2Args>(QUERY, {
    ...options
  });

  return result;
};
